import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Container, Row, Col, Carousel } from 'react-bootstrap';
import './carousel_ribbon.scss';

const CaseStudies = ({ data, type }) => {
  let edges = [];
  switch (type) {
    case 'Case Study (Ribbon)':
      edges = data.allNodeOrganisation.nodes;
      break;
    default:
      edges = [];
  }

  return (
    <>
      <div className={'casestudy-carousel d-md-none'}>
        <Items edges={edges} density={2} />
      </div>
      <div className={'d-none d-md-block d-xl-none'}>
        <Items edges={edges} density={3} />
      </div>
      <div className={'d-none d-xl-block'}>
        <Items edges={edges} density={4} />
      </div>
    </>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        allNodeOrganisation(
          filter: { field_featured: { eq: true } }
          sort: { fields: created, order: DESC }
        ) {
          nodes {
            id
            title
            field_link {
              uri
            }
            relationships {
              field_icon_dark {
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(height: 120, layout: FIXED)
                      }
                      publicURL
                    }
                  }
                }
              }
              field_icon_light {
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(height: 120, layout: FIXED)
                      }
                      publicURL
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <CaseStudies data={data} {...props} />}
  />
);

const Items = ({ edges, density }) => {
  let items = [];
  for (let i in edges) {
    if (i % density === 0) items.push({ children: [edges[i]] });
    else items[items.length - 1].children.push(edges[i]);
  }

  return (
    <Container style={{ paddingBottom: '30px' }}>
      <Carousel
        className="p-carousel-ribbon"
        interval={1000}
        indicators={false}
        controls={false}
      >
        {items.map((item, key) => {
          return (
            <Carousel.Item key={key}>
              <Container>
                <Row className="justify-content-center">
                  {item.children.map((child, key) => {
                    return (
                      <Col xs={12 / density} key={key}>
                        {child.relationships.field_icon_dark
                          .relationships.field_media_image.localFile
                          .childImageSharp && (
                          <a
                            href={child.field_link.uri}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <GatsbyImage
                              image={
                                child.relationships.field_icon_dark
                                  .relationships.field_media_image
                                  .localFile.childImageSharp
                                  .gatsbyImageData
                              }
                              imgStyle={{
                                objectFit: 'contain',
                                maxWidth: '100%',
                              }}
                              alt={child.title}
                            />
                          </a>
                        )}
                        {!child.relationships.field_icon_dark
                          .relationships.field_media_image.localFile
                          .childImageSharp && (
                          <a
                            href={child.field_link.uri}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={
                                child.relationships.field_icon_dark
                                  .relationships.field_media_image
                                  .localFile.publicURL
                              }
                              alt={child.title}
                              style={{
                                height: '140px',
                                maxWidth: '100%',
                              }}
                            />
                          </a>
                        )}
                      </Col>
                    );
                  })}
                </Row>
              </Container>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </Container>
  );
};
